import type { TopicItem } from '@/utils/mqtt-client/types';

// 订阅主题
const topics: TopicItem[] = [
    {
        name: 'number',
        path: '/crowdFunding/flow/:appId/:actId',
        data: {},
    },
    {
        name: 'backers',
        path: '/crowdFunding/product/sales/:appId/:actId',
        data: [],
    },
    {
        name: 'addedMainComments',
        path: '/comment/content/create/:appId/:actId',
        data: [],
    },
    {
        name: 'addedSubComments',
        path: '/comment/subcontent/create/:appId/:actId',
        data: [],
    },
    {
        name: 'addedDelComments',
        path: '/comment/content/detete/:appId/:actId',
        data: [],
    },
];

export default topics;
